import type { FC } from 'react';
import { Outlet } from 'react-router-dom';

import styles from './Legado.module.scss';

// ⚠️ ANDAIME DA MIGRAÇÃO — some junto com a última tela antiga (docs/redesenho/telas.md).
//
// As telas que ainda não foram redesenhadas no Carbon (src/ui-carbon) dependem das classes da casca
// antiga (`.task-app`, `.Main-section`) e de rolar dentro de uma caixa presa entre o topo e o
// rodapé. Esta moldura recria só isso, e só em volta delas: no App.tsx, toda rota que ainda está
// dentro de `<Legado>` é tela antiga. Migrar uma tela é tirar a rota daqui.

export const Legado: FC = () => (
  <div className={`task-app ${styles.moldura}`} data-legado=''>
    <div className='Main-section'>
      <Outlet />
    </div>
  </div>
);

export default Legado;
